import { inject, Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { maintenance } from "src/app/support/maintenance";
import { sntLog } from "src/app/common/logger";
import { MemberAuthProviderService } from "src/app/services/member-auth-provider/member-auth-provider.service";
import { getCurrentDomainName } from "src/app/core/domain-name";
import { getCurrentAccountNickName } from "src/app/core/account-nickname";

const logger = sntLog("ProvideMemberAuthGuard");

@Injectable()
export class ProvideMemberAuthGuard {
  readonly #bootstrapService = inject(BootstrapService);
  readonly #router = inject(Router);
  readonly #memberAuthProviderService = inject(MemberAuthProviderService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    logger.info(`canActivate`);

    const domain = getCurrentDomainName();
    const accountNickName = getCurrentAccountNickName();

    const provideResult = await this.#memberAuthProviderService.provide({
      domainSlug: domain,
      accountNickName
    });

    switch (true) {
      case !!provideResult.error: {
        maintenance(this.#router, {
          code: provideResult.error
        });

        return false;
      }
      default: {
        this.#bootstrapService.setAllMembers(provideResult.membersWithTenant!);
        this.#bootstrapService.setAvailableMembersAndTenants(
          provideResult.availableMembersAndTenants!
        );
        this.#bootstrapService.setCurrentTenant(provideResult.tenant!);
        this.#bootstrapService.setCurrentMemberAuth(provideResult.memberAuth!);

        return true;
      }
    }
  }
}
